"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.socialProjectUpdateSchema = exports.socialProjectCreateSchema = exports.socialProjectSchema = void 0;
const zod_1 = require("zod");
const slug_field_1 = require("../slug-field");
// Galeri görseli: MinIO'da tutulan resim URL'i. Yalnızca same-origin göreli yol
// (/…) veya http(s) — javascript:/data: şemalarını engelle.
const socialImageUrlSchema = zod_1.z
    .string()
    .refine((u) => /^\/(?!\/)/.test(u) || /^https?:\/\//i.test(u), "Geçersiz görsel URL'i");
// Full DB row schema — matches Prisma SocialProject model fields
exports.socialProjectSchema = zod_1.z.object({
    id: zod_1.z.string().cuid().optional(),
    slug: (0, slug_field_1.slugField)(191),
    slugEn: (0, slug_field_1.slugEnField)(191),
    title: zod_1.z.string().min(1).max(500),
    titleEn: zod_1.z.string().max(500).nullable().optional(),
    excerpt: zod_1.z.string().min(1),
    excerptEn: zod_1.z.string().nullable().optional(),
    content: zod_1.z.string().min(1),
    contentEn: zod_1.z.string().nullable().optional(),
    images: zod_1.z.array(socialImageUrlSchema).default([]),
    order: zod_1.z.number().int().default(0),
    published: zod_1.z.boolean().default(true),
});
// API verbatim create/update schemas (source of truth: apps/api/src/common/schemas.ts)
exports.socialProjectCreateSchema = zod_1.z.object({
    slug: (0, slug_field_1.slugField)(191),
    slugEn: (0, slug_field_1.slugEnField)(191),
    title: zod_1.z.string().min(1).max(500),
    titleEn: zod_1.z.string().max(500).nullable().optional(),
    excerpt: zod_1.z.string().min(1),
    excerptEn: zod_1.z.string().nullable().optional(),
    content: zod_1.z.string().min(1),
    contentEn: zod_1.z.string().nullable().optional(),
    images: zod_1.z.array(socialImageUrlSchema).default([]),
    order: zod_1.z.number().int().default(0),
    published: zod_1.z.boolean().default(true),
});
exports.socialProjectUpdateSchema = exports.socialProjectCreateSchema.partial().extend({
    id: zod_1.z.string().cuid(),
});
//# sourceMappingURL=social-project.js.map